// Revisión de catálogo de una compra (proveedor y productos reportados como texto por el cajero).
// Compartido por el detalle del cierre y el panel de Compras. Devuelven true si se guardó un cambio.
import Swal from 'sweetalert2';
import { buscarProveedores, resolverProveedor, buscarProductos, vincularProducto, crearProducto } from '../../services/data';

const escapar = (v) => String(v || '').replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;');

/** Proveedor: vincular a uno existente o crearlo en el catálogo (o dejarlo como texto). */
export async function revisarProveedorCompra(compra) {
  const candidatos = await buscarProveedores(compra.proveedorNombre || '');
  const opciones = candidatos.map((p) => `<option value="${escapar(p.id)}">${escapar(p.nombre)}</option>`).join('');
  const { value } = await Swal.fire({ title: 'Revisar proveedor',
    html: `<p>Nombre reportado: <b>${escapar(compra.proveedorNombre)}</b></p>
      <label>Buscar existente<input id="prov-buscar" class="swal2-input" placeholder="Buscar proveedor"></label>
      <label>Proveedor existente<select id="prov-existente" class="swal2-input"><option value="">Crear proveedor nuevo</option>${opciones}</select></label>
      <label>Nombre nuevo<input id="prov-nombre" class="swal2-input" value="${escapar(compra.proveedorNombre)}"></label>
      <label>Días de crédito<input id="prov-dias" class="swal2-input" type="number" min="0" max="365" placeholder="0"></label>
      <p>También puedes dejar el nombre únicamente como texto reportado.</p>`,
    showCancelButton: true, confirmButtonText: 'Guardar', cancelButtonText: 'Dejar como texto',
    didOpen: () => {
      let secuencia = 0;
      document.getElementById('prov-buscar').addEventListener('input', async (e) => {
        const actual = ++secuencia;
        try {
          const encontrados = await buscarProveedores(e.target.value);
          const select = document.getElementById('prov-existente');
          if (actual !== secuencia || !select) return;
          select.replaceChildren(new Option('Crear proveedor nuevo', ''));
          encontrados.forEach((p) => select.add(new Option(p.nombre, p.id)));
        } catch { /* Se conserva el texto escrito. */ }
      });
    },
    preConfirm: () => {
      const proveedorId = document.getElementById('prov-existente').value;
      const nuevoNombre = document.getElementById('prov-nombre').value.trim();
      const diasCredito = document.getElementById('prov-dias').value;
      if (!proveedorId && !nuevoNombre) { Swal.showValidationMessage('Indica un proveedor'); return false; }
      if (!proveedorId && (!/^\d+$/.test(diasCredito) || Number(diasCredito) > 365)) {
        Swal.showValidationMessage('Indica días de crédito entre 0 y 365'); return false;
      }
      return { proveedorId, nuevoNombre, diasCredito };
    } });
  if (!value) return false;
  await resolverProveedor({ compraId: compra.id, ...value });
  return true;
}

/** Producto: vincular a uno existente del catálogo o crearlo (o dejarlo como texto). */
export async function revisarProductoCompra(item) {
  const coincidencias = await buscarProductos(item.producto);
  const opciones = coincidencias.map((p) => `<option value="${escapar(p.id)}">${escapar(p.nombre)}</option>`).join('');
  const { value } = await Swal.fire({ title: 'Agregar al catálogo',
    html: `<p>Producto reportado: <b>${escapar(item.producto)}</b></p><label>Buscar existente<input id="producto-buscar" class="swal2-input" placeholder="Buscar producto"></label><label>Vincular producto existente<select id="producto-existente" class="swal2-input"><option value="">Crear producto nuevo</option>${opciones}</select></label><label>Nombre<input id="producto-nombre" class="swal2-input" value="${escapar(item.producto)}"></label><label>Unidad<select id="producto-unidad" class="swal2-input"><option>Unidad</option><option>Libra</option><option>Kilogramo</option><option>Litro</option><option>Galón</option><option>Caja</option><option>Paquete</option><option>Docena</option><option>Otro</option></select></label><label>Categoría<input id="producto-categoria" class="swal2-input"></label>`,
    showCancelButton: true, confirmButtonText: 'Guardar', cancelButtonText: 'Dejar como texto',
    didOpen: () => {
      let secuencia = 0;
      document.getElementById('producto-buscar').addEventListener('input', async (e) => {
        const actual = ++secuencia;
        try {
          const encontrados = await buscarProductos(e.target.value);
          const select = document.getElementById('producto-existente');
          if (actual !== secuencia || !select) return;
          select.replaceChildren(new Option('Crear producto nuevo', ''));
          encontrados.forEach((p) => select.add(new Option(p.nombre, p.id)));
        } catch { /* El texto reportado se conserva. */ }
      });
    },
    preConfirm: () => { const existente = document.getElementById('producto-existente').value;
      const nombre = document.getElementById('producto-nombre').value.trim();
      if (!existente && !nombre) { Swal.showValidationMessage('Indica el nombre del producto'); return false; }
      return { existente, nombre, unidad: document.getElementById('producto-unidad').value, categoria: document.getElementById('producto-categoria').value.trim() }; } });
  if (!value) return false;
  if (value.existente) await vincularProducto(item.id, value.existente);
  else await crearProducto({ compraItemId: item.id, nombre: value.nombre, unidad: value.unidad, categoria: value.categoria });
  return true;
}
